import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import SoftButton from "components/SoftButton";
import SoftTypography from 'components/SoftTypography';
import SoftBox from "components/SoftBox"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import toast from 'react-hot-toast';
import { baseURL } from 'utils/api';
import { useSelector } from 'react-redux';

const TermsAndConditions = ({ data, id, handelRefresh }) => {

  const [value, setValue] = useState('');
  const [madeChanges, setMadeChanges] = useState(false);
  const [loading, setLoading] = useState(false);
  const userTheme = useSelector((state) => state.commonSlice.theme);

  useEffect(() => {
    setValue(data)
  }, [data]);


  const updateProfile = (e) => {
    e.preventDefault();
    setLoading(true)

    fetch(`${baseURL}/profile/updateProfile2/${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ termsAndConditions: value })
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false)
        if (data.status === 200) {
          toast.success(data.message);
          handelRefresh()
        } else {
          toast.error(data.message)
        }
      }
      ).catch(err => {
        setLoading(false)
        toast.error(err.message || 'Something went wrong');
      });
  }

  const onChange = (value) => {
    setValue(value);
    setMadeChanges(true);
  }



  return (
    <SoftBox sx={{ padding: 3, margin: 'auto', width: "100%" }}>
      <SoftTypography variant="caption" paragraph>
        Please read and accept our Terms and Conditions before proceeding.
      </SoftTypography>

      <div className={`quill-wrapper ${userTheme === 'dark' ? 'dark-theme' : ''}`}>
        <ReactQuill
          theme="snow"
          value={value} onChange={onChange} />
      </div>

      <SoftBox sx={{ display: 'flex', mt: 4 }}>
        <SoftButton
          variant="gradient"
          color={madeChanges ? 'info' : 'light'}
          disabled={!madeChanges}
          sx={{ color: 'white', marginRight: 2 }}
          onClick={updateProfile}
          fullWidth
        >
          {
            loading ? <CircularProgress size={24} color='white' /> : 'Save Changes'
          }
        </SoftButton>
      </SoftBox>


    </SoftBox>
  );
};

export default TermsAndConditions;
